import React from "react";
import { useLocation, NavLink } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignOutButton } from "components/LoginandOutpage/SignOutButton.js";
import { useAuth } from "AuthProvider";
import "./Sidebar.css";
import passLogo from "../../assets/css/passLog.svg";
import packageJson from '../../../package.json';
const { version } = packageJson;

function Sidebar({ color, image, routes }) {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const { role } = useAuth();
  const activeRoute = (routeName) =>
    location.pathname.includes(routeName) ? "active" : "";

  return (
    <aside className="sidebar-modern" data-color={color} data-image={image}>
      <div className="sidebar-header">
        <img src={passLogo} alt="PASS Dashboard" className="brand-logo" />
      </div>
      <nav className="sidebar-nav">
        <ul>
          {routes.map(
            (prop, key) =>
              !prop.redirect &&
              prop.showInSidebar &&
              (!prop.adminOnly || role === 'admin') && (
                <React.Fragment key={key}>
                  <li className={activeRoute(prop.layout + prop.path)}>
                    <NavLink to={prop.layout + prop.path} className="nav-item">
                      <i className={`nav-icon ${prop.icon || "fi-grid"}`}></i>
                      <span>{prop.name}</span>
                    </NavLink>
                  </li>
                  {prop.name === "User Profile" && isAuthenticated && (
                    <li className="sidebar-signout-item">
                      <SignOutButton className="sidebar-signout-button" />
                    </li>
                  )}
                </React.Fragment>
              )
          )}
        </ul>
      </nav>
      <div className="sidebar-version">v{version}</div>
    </aside>
  );
}

export default Sidebar;
